// libs
import { Record } from "immutable";
import MenuCategory from "./MenuCategory";


const BaseRecord = Record({
  description: null, // string
  category1: null, // MenuCategory
  category2: null, // MenuCategory
  category3: null, // MenuCategory
  category4: null, // MenuCategory
  category5: null // MenuCategory
});

export default class MenuDrink extends BaseRecord {
  init(data) {
    console.log(data);
    let category1 = null;
    let category2 = null;
    let category3 = null;
    let category4 = null;
    let category5 = null;

    if (data.category[0]) {
      category1 = new MenuCategory().init(data.category[0]);
    }

    if (data.category[1]) {
      category2 = new MenuCategory().init(data.category[1]);
    }

    if (data.category[2]) {
      category3 = new MenuCategory().init(data.category[2]);
    }

    if (data.category[3]) {
      category4 = new MenuCategory().init(data.category[3]);
    }

    if (data.category[4]) {
      category5 = new MenuCategory().init(data.category[4]);
    }

    return this.withMutations(s =>
      s.set("description", data.description)
       .set("category1", category1)
       .set("category2", category2)
       .set("category3", category3)
       .set("category4", category4)
       .set("category5", category5)
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/MenuDrink.js